<template>
  <div>
    <VSectionBar
      id="trial"
      message="体験授業までの流れ"
    />
    <v-sheet
      class=main--text>
      <v-container
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=8>
            <v-timeline
              :dense="$vuetify.breakpoint.smAndDown">
              <v-timeline-item
                icon="fab fa-line">
                <v-card>
                  <v-container
                    fluid>
                    <v-row
                      justify=center
                      no-gutters>
                      <v-col
                        cols=auto>
                        <h2>公式LINEを友だち登録</h2>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-timeline-item>
              <v-timeline-item
                icon="fa-calendar-alt">
                <v-card>
                  <v-container
                    fluid>
                    <v-row
                      no-gutters
                      justify=center>
                      <v-col
                        cols=auto>
                        <h2>担当講師と日程を調整</h2>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-timeline-item>
              <v-timeline-item
                icon="fa-chalkboard-teacher">
                <v-card>
                  <v-container
                    fluid>
                    <v-row
                      no-gutters
                      justify=center>
                      <v-col
                        cols=auto>
                        <h2>体験授業を受講！</h2>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=8>
            <v-stepper
              vertical
              alt-labels
              non-liner
              >
              <v-row
                justify=center>
                <v-col
                  cols=auto>
                  <h2>カリキュラム</h2>
                </v-col>
              </v-row>
              <v-stepper-step
                complete
                step=1>
                自己紹介＆プログラミングとは
                <small>所要時間：約10分</small>
              </v-stepper-step>
              <v-stepper-step
                complete
                step=2>
                プログラミングレッスン
                <small>所要時間：約30分</small>
              </v-stepper-step>
              <v-stepper-step
                complete
                step=3>
                振り返り＆保護者様向けご説明
                <small>所要時間：約20分</small>
              </v-stepper-step>
            </v-stepper>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=8>
            <v-img :src="trialImage"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import VSectionBar from '@/components/molecules/VSectionBar.vue'
import TrialImage from '@/assets/img/trial.jpg'

export default {
  name: 'VTrialLesson',
  components: {
    VSectionBar
  },
  data: () => {
    return {
      trialImage: TrialImage
    }
  }
}
</script>